// extracted by mini-css-extract-plugin
export default {"investorListing":"investor-listing_investorListing__-F460","noDataFound":"investor-listing_noDataFound__Hq9Gc","invListItemWrapper":"investor-listing_invListItemWrapper__TlCtI"};